export default __webpack_public_path__ + "static/partner-tube-3-4f653ee0c04143bb87a51a47f1070ba0.png";